interface Props {
  icon?: React.ReactNode;
  text?: string;
  isForSuspend?: boolean;
}

const Loader = (props: Props) => {
  return (
    <div
      className={`flex flex-col justify-center items-center gap-y-3 ${
        props.isForSuspend && "h-full"
      }`}
    >
      <div>{props.icon}</div>
      <div>{props.text ?? "Loading..."}</div>
    </div>
  );
};

export default Loader;
